import type { PluginDefinition } from "../../types";

export interface QuickCheckConfig {
  question: string;
  options: string[];
  /** Author-facing only; absent from the config a student receives. */
  correct_index?: number;
}

export interface QuickCheckPayload {
  selected_index: number;
}

export const MIN_OPTIONS = 2;

export const QUICK_CHECK_DEFINITION: PluginDefinition<QuickCheckConfig> = {
  subType: "quick_check",
  label: "Quick Check",
  gradeable: true,
  gradingType: "auto",
  defaultConfig: () => ({ question: "", options: ["", ""], correct_index: 0 }),
  offeredComponents: () =>
    Promise.resolve([
      {
        label: "Quick Check",
        description: "A multiple-choice question scored automatically",
        icon: "fa-check-circle-o",
      },
    ]),
  loadComponents: () => Promise.all([import("./config/jnctQuickCheckConfig"), import("./student/jnctQuickCheckStudent"), import("./grading/jnctQuickCheckGrading")]),
};
